import { Project } from "pmt-types/src/models/Project.ts";
import { useMutationSearchEntities } from "./useMutationSearchEntities.ts";

export const useMutationSearchProjects = () =>
  useMutationSearchEntities<Project>("projects");
